import { AttachmentFile } from "@/components/Attachment/types";

export type ViewMode = "icons" | "list" | "columns";

export type EntityType =
  | "project"
  | "shift"
  | "client"
  | "user"
  | "contact"
  | "invoice"
  | "estimate"
  | "time_card"
  | "investigation"
  | "course"
  | "expense"
  | "incident"
  | "payroll"
  | "billing_item";

export interface FilesTabProps {
  entityType: EntityType;
  entityId?: string;
  loading?: boolean;
  canUpload?: boolean;
  canRename?: boolean;
  canDelete?: boolean;
}

export interface FileViewProps {
  files: AttachmentFile[];
  onFileRemove?: (fileId: string) => void;
  onFileRename?: (fileId: string, newName: string) => void;
  onFilePreview?: (file: AttachmentFile) => void;
  onExpandImage?: (url: string, name: string) => void;
}

export interface FileItemProps {
  file: AttachmentFile;
  mode: ViewMode;
  onRemove: () => void;
  onPreview?: () => void;
}
